import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '../utils/supabase/client';
// Fetch all text elements
export const useTexts = (options = {}) => {
  return useQuery({
    queryKey: ['texts'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('texts')
        .select('*')
        .order('id', { ascending: true });

      if (error) {
        console.error('Error fetching texts:', error);
        throw new Error(error.message);
      }

      return data;
    },
    ...options,
  });
};

// Add a new text element
export const useAddText = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (newText) => {
      const { data, error } = await supabase
        .from('texts')
        .insert([{
          section_id: newText.section_id,
          content: newText.content,
          x: newText.x,
          y: newText.y,
          width: newText.width,
          height: newText.height,
          rotation: newText.rotation,
          display_number: newText.display_number,
        }])
        .select()
        .single();

      if (error) {
        console.error('Error adding text:', error);
        throw new Error(error.message);
      }

      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['texts'] });
    },
    onError: (error) => {
      console.error('Mutation error adding text:', error);
    },
  });
};

// Update an existing text element
export const useUpdateText = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (updatedText) => {
      const { data, error } = await supabase
        .from('texts')
        .update({
          section_id: updatedText.section_id,
          content: updatedText.content,
          x: updatedText.x,
          y: updatedText.y,
          width: updatedText.width,
          height: updatedText.height,
          rotation: updatedText.rotation,
          display_number: updatedText.display_number,
        })
        .eq('id', updatedText.id)
        .select()
        .single();

      if (error) {
        console.error('Error updating text:', error);
        throw new Error(error.message);
      }

      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['texts'] });
    },
    onError: (error) => {
      console.error('Mutation error updating text:', error);
    },
  });
};

// Delete a text element
export const useDeleteText = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id }) => {
      const { error } = await supabase
        .from('texts')
        .delete()
        .eq('id', id);

      if (error) {
        console.error('Error deleting text:', error);
        throw new Error(error.message);
      }

      return id;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['texts'] });
    },
    onError: (error) => {
      console.error('Mutation error deleting text:', error);
    },
  });
};